import { render, staticRenderFns } from "./CostBearerLivePayDetails.vue?vue&type=template&id=3ecc70be"
import script from "./CostBearerLivePayDetails.vue?vue&type=script&lang=ts"
export * from "./CostBearerLivePayDetails.vue?vue&type=script&lang=ts"
import style0 from "./CostBearerLivePayDetails.vue?vue&type=style&index=0&id=3ecc70be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports